var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$options.name, { '-visible': this.isPreloading }]},[_c('div',{staticClass:"brand"},[_c('brand-logo',{ref:"logo",attrs:{"color":"#F7A786"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }